import type { IconProps } from './GearIcon'

export function RulebookIcon({ width = 20, height = 20, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={width} height={height} fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M4.5 5.5C4.5 4.4 5.4 3.5 6.5 3.5H18a1.5 1.5 0 0 1 1.5 1.5v14.5H7.5A3 3 0 0 0 4.5 22V5.5Z" />
      <path d="M7.5 19.5c-1.7 0-3 1.3-3 3h12.75a2.25 2.25 0 0 0 2.25-2.25V5" />
      <path d="M8.5 7.5h7" />
      <path d="M8.5 11h7" />
      <path d="M8.5 14.5h4.5" />
    </svg>
  )
}
